import { OVERRIDE_CANCELLATION_REFUND } from '../../constants/actions/policy';

export function overrideCancellationRefund(payload) {
    return {
        type: OVERRIDE_CANCELLATION_REFUND,
        payload,
    };
}
